import React from 'react';
import { NumberTextField } from '../BuildingBlocks/Form/NumberTextField';
import { useMobile } from '../../hooks/useMobile';
import Typography from '@material-ui/core/Typography/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  text: {
    fontWeight: 700,
    color: theme.palette.brand.greenDark,
  },
}));

interface IRecentlySales {
  register: any;
  errors?: any;
}
export default function RecentlySales({ register, errors }: IRecentlySales) {
  const mobile = useMobile();
  const classes = useStyles({ mobile });

  return (
    <>
      <Typography variant={'h6'} className={classes.text}>
        How have your sales been recently?
      </Typography>
      <Typography variant={'subtitle2'} gutterBottom>
        In the last 3 months I sold:{' '}
      </Typography>

      <NumberTextField
        errors={errors}
        label={'Sales in last 3 months'}
        name={'threeMonthsSales'}
        TextFieldProps={{
          ...register('threeMonthsSales', {
            required: {
              value: true,
              message: 'This field is required.',
            },
          }),
        }}
      />
    </>
  );
}
